import ReactS3Uploader from 'react-s3-uploader';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Uploader = styled(ReactS3Uploader)`
  display: none;
`;

const images = ['image/png', 'image/jpeg', 'image/jpg'];

const pdf = ['application/pdf'];

const pgn = ['.pgn'];

const acceptedInputs = {
  allFiles: [...images, ...pdf, ...pgn],
  pdfImages: [...images, ...pdf],
  pdf,
  pgn,
  images
};

const doNothing = () => {};

const S3Uploader = ({
  id,
  getSignedUrl,
  onUploadStart,
  onUploadError,
  onUploadFinish,
  onUploadProgress,
  acceptedFiles,
  accessRef
}) => (
  <Uploader
    id={id}
    signingUrlMethod="GET"
    getSignedUrl={getSignedUrl}
    accept={acceptedInputs[acceptedFiles]}
    s3path=""
    preprocess={onUploadStart}
    onError={onUploadError}
    onFinish={onUploadFinish}
    onProgress={onUploadProgress}
    signingUrlWithCredentials={false}
    uploadRequestHeaders={{ 'x-amz-acl': 'public-read' }}
    contentDisposition="auto"
    inputRef={accessRef}
  />
);

export default S3Uploader;

S3Uploader.propTypes = {
  id: PropTypes.string,
  getSignedUrl: PropTypes.func.isRequired,
  onUploadStart: PropTypes.func.isRequired,
  onUploadError: PropTypes.func.isRequired,
  onUploadFinish: PropTypes.func.isRequired,
  accessRef: PropTypes.func,
  acceptedFiles: PropTypes.oneOf(Object.keys(acceptedInputs)).isRequired,
  onUploadProgress: PropTypes.func
};

S3Uploader.defaultProps = {
  id: 'uploadFile',
  onUploadProgress: doNothing,
  accessRef: doNothing
};
